function UpperModal() {
	this.frame = (window.$socket_up5 && window.$socket_up5.mode == "parent" ? true : false);
	this.modal = "#upperModal";

	function getInstance(modal) {
		return $("#upperModal").first();
	}

	var instance = null;

	this.create = function(container) {
		if (window.$socket_up5 && window.$socket_up5.mode == "parent") {
			$socket_up5.emit('modal create', container);
			return;
		}
		instance = getInstance();

		if (instance) {
			this.destroy();
		}

		if (!container) {
			container = "body";
		}

		var template = $(modalTemplate);
		$(container).append(template);
		return this;
	};

	this.update = function(data, show) {
		if (window.$socket_up5 && window.$socket_up5.mode == "parent") {
			$socket_up5.emit('modal update', [data, show]);
			return;
		}
		instance = getInstance();

		if (instance) {
                    if (data.title) {
                        instance.find('.modal-title').html(data.title).show();
                    } else {
                        instance.find('.modal-title').hide();
                    }

                    if (data.subtitle) {
                        instance.find('.modal-subtitle').html(data.subtitle).show();
                    } else {
                        instance.find('.modal-subtitle').hide();
                    }

                    if (data.large) {
                        instance.find('.modal-dialog').addClass('modal-lg');
                    }

                    if (data.content) {
                        instance.find('.modal-body').html(data.content);
                    }

                    if (data.headershadow) {
                        instance.find('.modal-header').addClass('modal-header--shadow');
                    } else {
                        instance.find('.modal-header').removeClass('modal-header--shadow');
                    }

                    if (data.footer) {
                        var modalHasFooterAdded = (instance.find('.modal-content .modal-footer').length > 0);
                        if (!modalHasFooterAdded) {
                            instance.find('.modal-content').append($('<div/>', {
                                "class": "modal-footer"
                            }).html(data.footer));
                        }
                    }

                    if (show) {
                        instance.modal('show');

                        setTimeout(function () {
                            $('.modal-backdrop').addClass('modal-backdrop--upper');
                        });
                    }
		}
		return this;
	};

	this.show = function() {
		if (window.$socket_up5 && window.$socket_up5.mode == "parent") {
			$socket_up5.emit('modal show', null);
			return;
		}
		instance = getInstance();

		if (instance) {
			instance.modal('show');

            setTimeout(function () {
                $('.modal-backdrop').addClass('modal-backdrop--upper');
            });
		}
		return this;
	};

	this.hide = function() {
		if (window.$socket_up5 && window.$socket_up5.mode == "parent") {
			$socket_up5.emit('modal hide', null);
			return;
		}
		instance = getInstance();
		if (instance) {
			instance.modal('hide');
		}
		return this;
	};

	this.destroy = function() {
		if (window.$socket_up5 && window.$socket_up5.mode == "parent") {
			$socket_up5.emit('modal destroy', null);
			return;
		}
		instance = getInstance();
		if (instance) {
			instance.remove();
		}
		return this;
	};

	var modalTemplate = $('<div/>', {
		"id": "upperModal",
		"class": "modal fade",
		"tabindex": "-1"
	}).append(
		$('<div/>', {
			"class": "modal-dialog"
		}).append(
			$('<div/>', {
				"class": "modal-content"
			}).append([
				$('<div/>', {
					"class": "modal-header"
				}).append([
					$('<button/>', {
						"class": "close",
						"type": "button",
						"data-dismiss": "modal",
					})
				], [
					$('<h4/>', {
						"class": "modal-title"
					})
				])
			], [
				$('<div/>', {
					"class": "modal-body"
				}).html('')
			])
		)
	);
	return this;
}

var modalDialog = {};

$(document).ready(function() {
	modalDialog = new UpperModal();
	modalDialog.create();
	modalDialog.hide();

	$(document).on('click', '.link-open-frame', function(e) {
		var $btn = $(this);
		var data = $btn.data();
		if (window.parent && data && data.offer) {
			e.preventDefault();
			window.parent.postMessage(JSON.stringify({
				e: 'link offer',
				d: {
					offerId: data.offerId,
					url: $btn.attr('href')
				}
			}), '*');
		}
	});
});

if (!window.$socket_up5) {
	var U5 = {};

	U5.popover_close = function(ev) {
		$('[data-toggle="popover"],[data-toggle="adjust-popover"]').each(function() {
			if (!$(this).is(ev.target) && $(this).has(ev.target).length === 0 && $('.popover').has(ev.target).length === 0) {
				$(this).popover('hide');
			}
		});
	};

	$(function() {
		$(document).on('click', 'body', function(e) {
			U5.popover_close(e);
		});

		_reinit();

		$(document).on('click', '[data-toggle="modal"]', function(e) {
			var $this = $(this),
				data = $this.data();
			if (data.content) {
				e.preventDefault();
				e.stopPropagation();
				ModalDialog(data);
			}
		});
	});


	function ModalDialog(data) {
		modalDialog.update(data, true);
		return false;
	}

	function _reinit() {
		if ($.fn.tooltip) {
			$('[data-toggle="tooltip"]').tooltip();
		}
		if ($.fn.popover) {
			$('[data-toggle="popover"]').popover();
		}
	}

	var $ajaxModal, $ajaxModalName;

	function AjaxDescriptionModal(mData) {
		var subtitle = '';
		if (mData.checkin) {
			subtitle += '' + mData.checkin;
		}
		if (mData.checkout) {
			subtitle += '' + mData.checkout;
		}
		if ($ajaxModal && mData && $ajaxModalName == mData.mode + '-' + mData.id + subtitle) {
			modalDialog.show();
			return;
		}

		if (mData && mData.url) {
			$.ajax(mData.url, {
				dataType: "json",
				success: function(res) {
					if ($ajaxModal && res && res.error === false) {
						modalDialog.update({
							title: mData.title,
                                                        subtitle: mData.subtitle,
							large: (mData.large ? true : false),
                                                        headershadow: (mData.headershadow),
							content: res.content
						}, true);
					} else if (res.error === true) {
						modalDialog.update({
							title: mData.title,
                                                        subtitle: mData.subtitle,
							large: (mData.large ? true : false),
                                                        headershadow: (mData.headershadow),
							content: res.message
						}, true);
					}
				},
				error: function(res) {
					modalDialog.update({
						content: 'error'
					}, true);
					$ajaxModalName = null;
				},
				beforeSend: function(res) {
					modalDialog.update({
						title: mData.title,
                                                subtitle: mData.subtitle,
						large: (mData.large ? true : false),
                                                headershadow: (mData.headershadow),
						content: (mData.headershadow ? '<div class="up5-desc-gallery up5-desc-gallery--backup-image">' : '') + '<div class="up5-loader__spinner" style="float: none; margin: 0 auto;"><svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g transform="translate(1 1)" stroke-width="2"><circle class="circle" stroke-opacity=".5" cx="18" cy="18" r="18"/><path d="M36 18c0-9.94-8.06-18-18-18"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite"/></path></g></g></svg></div>' + (mData.headershadow ? '</div>' : ''),
					}, true);
					$ajaxModal = true;
					$ajaxModalName = mData.mode + '-' + mData.id + subtitle;
				}
			});
		}
	}

	function ScrollTo(target, speed, callback) {
		if (!speed) {
			speed = 'slow';
		}

		if (window.$socket_up5 && !window.SidebarMode) {
            var target = '.upper6_frame';
            var offset = typeof $('body').attr('data-header-offset') !== 'undefined' ? parseInt($('body').attr('data-header-offset')) : 0;

            /* 42px - height of header in centerng */
            offset = $('body').hasClass('frame--gc') ? 42 : offset;

			window.$socket_up5.emit('scroll to', {
				target: target,
				speed: speed,
                offset: offset,
				callback: callback
			});

			return null;
		} else {
			if ($(target).length > 0) {
				$('body,html').animate({
					scrollTop: $(target).offset().top
				}, speed, "linear", (callback ? callback : function() {}));
			}
		}
	}

}

function CloseAllPopovers(except) {
    var except = typeof except !== 'undefined' ? except : false;

    if (except && typeof except === 'string') {
        var elements = $('[data-toggle="popover"], [data-toggle="adjust-popover"]').not(except);
    } else {
        var elements = $('[data-toggle="popover"], [data-toggle="adjust-popover"]');
    }

    elements.each(function() {
        $(this).popover('hide');
    });
}
